// extracted by mini-css-extract-plugin
export default {"container":"analyticsCard_container__pGtw5","value":"analyticsCard_value__MGDua","name":"analyticsCard_name__h9nry","slide-in-bottom":"analyticsCard_slide-in-bottom__06PKN"};